import { createApp } from 'vue'
import App from './App.vue'

import * as global_utils from '@/utils/global_utils'
import Ant from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'
import { message } from 'ant-design-vue';
import '@/assets/css/global.css'
import axios_service from '@/utils/request'
import * as echarts from 'echarts/core';
import router from '@/components/router/index'
import { permission_manager } from '@/utils/permissions'
import { compute_route_permission_key } from '@/utils/permission_utils'
// import '@/assets/fonts/fonts.css'
import { CanvasRenderer } from 'echarts/renderers'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, PieChart, GaugeChart, LineChart  } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent
} from 'echarts/components'
import '@/assets/fonts/fonts.css'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale,
    LinearScale, PointElement, LineElement, LineController, ArcElement,
}
    from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isoWeek)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)


ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
    PointElement, LineElement, LineController, ArcElement,
)
ChartJS.register(ChartDataLabels);

const app = createApp(App)

app.use(router)
app.use(Ant)


// 按需注册的组件
echarts.use([
    CanvasRenderer,     // 渲染器
    BarChart,   // 柱状图
    PieChart,    // 饼图
    LineChart,      // 折线图
    GaugeChart,
    ToolboxComponent,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
]);
app.config.globalProperties.$echarts = echarts
// 挂载一个自定义属性$axios
app.config.globalProperties.$axios = axios_service
// 挂载global_utils.js中的全局函数
app.config.globalProperties.$global_utils = global_utils


const icons = Icons
for (const i in icons){
    app.component(i, icons[i])
}
app.mount('#app')

// 路由守卫
router.beforeEach(async function(to, from, next) {
    if (to.meta.authentication_skip === true) {
        next()
        return
    }
    let user_token = sessionStorage.getItem('Authorization')
    let user_data = JSON.parse(sessionStorage.getItem('user_data'))
    if(!user_token){
        message.warning('The authentication has expired, please log in again.')
        next('/login')
        return
    }
    if (to.meta.role) {
        if (!to.meta.role.includes(user_data.role_id)) {
            message.warning('Permission is not passed.')
            next('/403')
            return
        }
    }

    // 细粒度权限拦截：用户手动输入无权限路由时重定向到 403
    // 从登录页进入时刷新权限（登录前 PermissionManager 初始化为空）
    if (from.meta.authentication_skip === true) {
        await permission_manager.reload()
    } else {
        await permission_manager.ensure_loaded()
    }
    let perm_key = compute_route_permission_key(to)
    if (perm_key && !permission_manager.valid(perm_key)) {
        message.warning('You do not have permission to access this page.')
        next('/403')
        return
    }

    next()
})

